export * from './quadratic-function.model';
export * from './quadratic-function.metadata';
export * from './quadratic-function.widget';
export * from './presets';
